import HttpRequest from "./HttpRequest";

export default class TableService {

  httpRequest = new HttpRequest();

  getData(url) {
    return this.httpRequest.get(url);
  }

}


// WEBPACK FOOTER //
// ./src/services/TableService.js